export default __webpack_public_path__ + "static/store-preview-2fbd0769b2ed5f6023b93c8553a4fb65.webm";